import { render } from "./App.vue?vue&type=template&id=751251b7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=751251b7&lang=scss"

import exportComponent from "/home/ubuntu/changlei/roblox-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__